var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',_vm._b({staticClass:"arrow-link px-0",attrs:{"text":"","tile":""}},'VBtn',_vm.$attrs,false),[_c('VIcon',{staticClass:"mr-4",attrs:{"color":"primary"}},[_vm._v("mdi-arrow-right")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }